export default __webpack_public_path__ + "static/m-team5-567b5ea3f7a89e0cd6b29e6ad0180e80.jpg";